<mat-form-field appearance="fill" *ngIf="appearance === 'fill'">
    <mat-label>Company</mat-label>
    <mat-select
        panelClass="mat-select-search"
        [formControl]="companyCtrl"
        [compareWith]="compareCompanyFn"
        [sbTestSelector]="sbTestSelector"
        (opened)="searchInput.focus()"
        (closed)="companySearch.reset()"
        #companySelect
    >
        <mat-select-trigger *ngIf="companyCtrl.value">
            <span
                class="d-inline-flex align-items-center mw-100 overflow-hidden"
                style="top: -6px; position: absolute"
            >
                <sb-company-logo
                    [companyWebsite]="companyCtrl.value.instrumentData?.website"
                    [countryCode]="
                        companyCtrl.value.instrumentData?.country
                            | countryCode : companyCtrl.value.currency
                    "
                    [type]="
                        companyCtrl.value?.instrumentData?.privateAssetType ??
                        companyCtrl.value?.type
                    "
                    class="me-3"
                ></sb-company-logo>
                <span
                    class="text-truncate pe-3"
                    [matTooltip]="
                        companyCtrl.value.decoratedInstrumentName ||
                        companyCtrl.value.name
                    "
                >
                    {{
                        companyCtrl.value.decoratedInstrumentName ||
                            companyCtrl.value.name
                    }}
                </span>
            </span>
        </mat-select-trigger>
        <header>
            <mat-form-field>
                <input
                    #searchInput
                    matInput
                    placeholder="Type to search"
                    type="text"
                    [sbTestSelector]="sbTestSelector"
                    (keydown.space)="$event.stopPropagation()"
                    (keydown.enter)="addNewBtn.click()"
                    [formControl]="companySearch"
                />
            </mat-form-field>
        </header>
        <main *ngIf="companies$ | async as companies" [sbTestSelector]="sbTestSelector">
            <ng-container *ngIf="companies.length > 0">
                <mat-option
                    *ngFor="let company of companies"
                    [value]="company"
                    [sbTestSelector]="sbTestSelector"
                >
                    <!-- TODO: country code should use pipe instead of function -->
                    <sb-company-logo
                        [companyWebsite]="company.instrumentData?.website"
                        [companyName]="company.decoratedInstrumentName"
                        [countryCode]="
                            company.instrumentData?.country
                                | countryCode : company.currency
                        "
                        class="me-3"
                    ></sb-company-logo>
                    {{ company.decoratedInstrumentName }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="companies.length === 0">
                <div role="alert" class="info mx-3 mt-0">
                    <strong>No match found!</strong>
                </div>
            </ng-container>
        </main>
        <footer>
            <a
                #addNewBtn
                [routerLink]="[
                    '',
                    {
                        outlets: {
                            dialog: [
                                'data-entry',
                                'private-equity',
                                'add-company',
                                searchInput.value
                            ]
                        }
                    }
                ]"
                [sbTestSelector]="sbTestSelector"
                class="btn primary"
                (click)="companySelect.close()"
            >
                Add new
            </a>
        </footer>
    </mat-select>
    <mat-hint>Select company</mat-hint>
</mat-form-field>
<mat-select
    class="sb-appearance-none"
    panelClass="mat-select-search"
    *ngIf="appearance === 'none'"
    [formControl]="companyCtrl"
    [compareWith]="compareCompanyFn"
    [sbTestSelector]="sbTestSelector"
    (opened)="searchInput.focus()"
    (closed)="companySearch.reset()"
    #companySelect
    placeholder="Select company"
>
    <mat-select-trigger *ngIf="companyCtrl.value">
        {{ companyCtrl.value.decoratedInstrumentName || companyCtrl.value.name }}
    </mat-select-trigger>
    <header>
        <mat-form-field>
            <input
                #searchInput
                matInput
                placeholder="Type to search"
                type="text"
                [sbTestSelector]="sbTestSelector"
                (keydown.space)="$event.stopPropagation()"
                [formControl]="companySearch"
            />
        </mat-form-field>
    </header>
    <main *ngIf="companies$ | async as companies" [sbTestSelector]="sbTestSelector">
        <ng-container *ngIf="companies.length > 0">
            <mat-option
                *ngFor="let company of companies"
                [value]="company"
                [sbTestSelector]="sbTestSelector"
            >
                <!-- TODO: flag should use company country if present -->
                <sb-company-logo
                    [companyWebsite]="company.instrumentData?.website"
                    [companyName]="company.decoratedInstrumentName"
                    [countryCode]="
                        company.instrumentData?.country | countryCode : company.currency
                    "
                    class="me-3"
                ></sb-company-logo>
                {{ company.decoratedInstrumentName }}
            </mat-option>
        </ng-container>
        <ng-container *ngIf="companies.length === 0">
            <div role="alert" class="info mx-3 mt-0">
                <strong>No match found!</strong>
            </div>
        </ng-container>
    </main>
    <footer>
        <a
            [routerLink]="[
                '',
                {
                    outlets: {
                        dialog: [
                            'data-entry',
                            'private-equity',
                            'add-company',
                            searchInput.value
                        ]
                    }
                }
            ]"
            [sbTestSelector]="sbTestSelector"
            class="btn primary"
            (click)="companySelect.close()"
        >
            Add new
        </a>
    </footer>
</mat-select>
